import React from 'react';
import styled from 'styled-components';
import { Flex, Box, Text } from 'rebass/styled-components';

const MobileAppContainer = styled.section`
  position: relative;
  width: 100%;
  background-color: #ff4f00;
  padding: 40px 0;
  font-family: 'Sk-Modernist-Regular', sans-serif;

  @media (max-width: 768px) {
    padding: 60px 0;
  }
`;

const ContentWrapper = styled(Flex)`
  padding: 0 20px;
  max-width: 1300px;
  margin: 0 auto;
  align-items: center;
  gap: 60px;

  @media (max-width: 992px) {
    flex-direction: column;
    text-align: center;
    gap: 40px;
  }
`;

const TextSection = styled(Box)`
  max-width: 600px;
  color: white;

  @media (max-width: 992px) {
    max-width: 100%;
  }
`;

const MainHeading = styled.h2`
  font-weight: 400;
  margin-bottom: 24px;

  font-size: 48px;
  line-height: 1.2;

  @media (max-width: 1024px) {
    font-size: 40px;
  }

  @media (max-width: 768px) {
    font-size: 30px;
  }

  @media (max-width: 480px) {
    font-size: 26px;
  }
`;

const SubText = styled(Text)`
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    font-size: 15px;
  }
`;

const StoreBadgesFlex = styled(Flex)`
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;

  @media (max-width: 992px) {
    justify-content: center;
  }

  img {
    height: 55px;

    @media (max-width: 480px) {
      height: 45px;
    }
  }
`;

const VisualSection = styled(Box)`
  position: relative;
  width: 100%;
  max-width: 500px;

  /* remove negative margin on mobile */
  margin-top: -120px;

  @media (max-width: 992px) {
    margin-top: 0;
    max-width: 350px;
  }

  @media (max-width: 480px) {
    max-width: 280px;
  }
`;

const PhoneFrame = styled.img`
  width: 130%;
  height: auto;
  display: block;
  margin-top: -30px;

  @media (max-width: 480px) {
    width: 100%;
    margin-top: 0px;
  }
`;

const MobileApp = () => {
  return (
    <MobileAppContainer>
      <ContentWrapper>
        {/* TEXT */}
        <TextSection>
          <MainHeading>Our Mobile App is Coming Soon</MainHeading>

          <SubText>
            We’re creating a mobile app to make managing your repeat prescriptions even easier. Soon, you’ll be able to
            view, order, and track everything directly from your phone.
          </SubText>

          <Text mb={3} fontWeight="bold">
            Available soon in
          </Text>

          <StoreBadgesFlex>
            <img src="/images/google-play-badge.svg" alt="Google Play" />
            <img src="/images/app-store-badge.svg" alt="App Store" />
          </StoreBadgesFlex>
        </TextSection>

        {/* IMAGE */}
        <VisualSection>
          <PhoneFrame src="/images/mobile-app.svg" alt="Mobile App" />
        </VisualSection>
      </ContentWrapper>
    </MobileAppContainer>
  );
};

export default MobileApp;
